"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  mutation verifyUserPhoneAuthentication($email: String, $phoneNumber: String, $phoneVerificationToken: String!){
    verifyUserPhoneAuthentication(email: $email, phoneNumber: $phoneNumber, phoneVerificationToken: $phoneVerificationToken) {
      token,
      user {
        orgContextId
        role {
          role
          __typename
        }
      }
    }
  }
`;
exports.default = query;
//# sourceMappingURL=verifyUserPhoneAuthentication.mutation.js.map